// @ts-check
import { PureComponent } from 'react'

const DEFAULT_TIMER = 60

class CountdownTimer extends PureComponent {
  state = {
    timeLeft: this.props.seconds
  }

  /** @type {number} */
  timer

  componentDidMount () {
    this.startTimer()
  }

  componentWillUnmount () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  render () {
    return this.secondsToTime(this.state.timeLeft)
  }

  startTimer = () => {
    if (this.timer) {
      clearInterval(this.timer)
    }

    this.setState({ timeLeft: this.props.seconds })

    this.timer = window.setInterval(() => {
      if (this.state.timeLeft > 0) {
        this.tick()
      } else {
        clearInterval(this.timer)
        this.stopTimer()
      }
    }, 1000)
  }

  tick = () => this.setState({ timeLeft: this.state.timeLeft - 1 })

  stopTimer = () => {
    this.setState({ timeLeft: 0 })
    this.props.onEnd()
  }

  /**
   * @param {number}  secs
   * @returns {string}
   */
  secondsToTime = (secs) => {
    const divisorForMinutes = secs % (60 * 60)
    const minutes = Math.floor(divisorForMinutes / 60)
    const divisorForSeconds = divisorForMinutes % 60
    const seconds = Math.ceil(divisorForSeconds)
    return `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
  }
}

CountdownTimer.defaultProps = {
  seconds: DEFAULT_TIMER,
  onEnd: () => {}
}

export { CountdownTimer }
